import { getToday } from '@/utils';
import {
  boolean,
  date,
  number,
  object,
  string,
} from '@/validations/custom-yup';

/** 調整額 */
export const balanceAdjustDifferenceBalanceSchema = number()
  .label('調整額')
  .required(({ label }) => `${label}を入力してください。`)
  .integer(({ label }) => `${label}には0より大きい整数を入力してください。`)
  .positive(({ label }) => `${label}には0より大きい整数を入力してください。`);

/** 加算フラグ */
export const balanceAdjustIsDepositSchema = boolean()
  .required()
  .defined()
  .default(true);

/** 調整理由 */
export const balanceAdjustReasonSchema = string()
  .label('調整理由')
  .required(({ label }) => `${label}を入力してください。`)
  .max(50, ({ label }) => `${label}は50文字以内で入力してください。`);

/** 有効期限無効化フラグ */
export const balanceAdjustIgnoreExpiredDateSchema = boolean()
  .required()
  .defined()
  .default(false);

/** 有効期限 */
export const balanceAdjustExpiredDateSchema = date()
  .label('有効期限')
  .when('ignoreExpiredDate', {
    is: true,
    then: (it) => it.notRequired(),
    otherwise: (it) => it.when('isDeposit', {
      is: true,
      then: (o) => o.required(({ label }) => `${label}を設定してください。`)
        .min(getToday(), ({ label }) => `${label}には現在日以降を指定してください。`),
      otherwise: (o) => o.notRequired(),
    }),
  });

const balanceAdjustSchemaType = {
  differenceBalance: balanceAdjustDifferenceBalanceSchema,
  isDeposit: balanceAdjustIsDepositSchema,
  reason: balanceAdjustReasonSchema,
};

/** 有効期限項目なしのバリデーション */
export const balanceAdjustSchema = object(balanceAdjustSchemaType);

/** 有効期限項目ありのバリデーション */
export const balanceAdjustScheduleTypeSchema = object({
  ...balanceAdjustSchemaType,
  ignoreExpiredDate: balanceAdjustIgnoreExpiredDateSchema,
  expiredDate: balanceAdjustExpiredDateSchema,
});
